import { render } from "./addsubcategory.vue?vue&type=template&id=e72885ec"
import script from "./addsubcategory.vue?vue&type=script&lang=js"
export * from "./addsubcategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__